import React from "react";
import { supabase, APP_BASE_URL } from "../lib/supabase";
import { Button } from "../components/ui/button";
import { Card } from "../components/ui/card";

// ============================================================================
// LAYAR LOGIN — latar bergambar, 10 September 2026.
//
// ⛔ INI PENGGANTIAN TAMPILAN. Nol satu pun perilaku berubah: `handleGoogleLogin`
//    identik baris demi baris, `data-testid` sama persis, teks whitelist sama.
//    Dijaga mesin oleh `backend/tests/test_layar_login_kontrak.py` — dan pagar
//    itu menuntut tiap testid ADA (bukan sekadar "nol ada yang hilang"), sebab
//    pemeriksa yang cuma menuntut ketiadaan tetap hijau saat ada yang
//    DITAMBAHKAN di tempat yang salah.
//
// ⛔ NOL ADA JUDUL ATAU LOGO DI HTML — vonis Owner. Wordmark `etamsios` dan
//    headline "Melangkah maju. Tetap berintegritas." sudah TERPANGGANG di
//    pikselnya; menambahkannya lagi berarti dua logo di satu layar.
//
//    ⚠ Konsekuensinya wajib diketahui, bukan ditemukan belakangan: teks
//      terpanggang NOL TERBACA pembaca layar. `sr-only` di bawah adalah
//      satu-satunya nama produk yang tersisa di DOM — ia NOL TERLIHAT MATA,
//      jadi ia nol melanggar vonis "nol ada logo kedua".
//
// ============================================================================
// KENAPA BENTUKNYA BEGINI — semuanya dari pengukuran, bukan selera
// ============================================================================
//
// 1. KARTU NOL PERNAH TRANSPARAN. Token teks yang dipakai di sini diukur di
//    atas gambarnya sendiri: 1,12:1 di atas langit, 7,97:1 di atas matahari
//    terbit — GAMBAR YANG SAMA. Nol ada satu warna teks yang aman di seluruh
//    permukaan latar bergambar, jadi nol satu huruf pun ditaruh langsung di
//    atas foto. Di atas kartu legap, rasionya tetap 16,94:1 / 4,99:1.
//
// 2. KARTU DI KIRI-BAWAH (lanskap). Peta energi tepi gambar desktop: kolom
//    0-20% baris 50-95% adalah blok TERKOSONG (22-48 dari 99), sementara
//    headline menempati baris 24-44% dan burungnya mulai kolom 54%. Kartu di
//    TENGAH menabrak keduanya.
//
// 3. POTRET: GAMBAR DI ATAS, KARTU DI BAWAHNYA — bukan kartu menindih gambar.
//    Pita kosong di gambar potret cuma baris 26-40% (±14% tinggi layar = 114px
//    di HP 812px); kartu butuh ±240px. Ia NOL MUAT. Vonis Owner: memotong
//    subjek demi kartu berarti memakai gambar yang subjeknya nol kelihatan —
//    dan gambar begitu nol ada gunanya.
//
// 4. PEMILIHAN GAMBAR MENURUT ORIENTASI, BUKAN LEBAR. Diukur: gambar lanskap
//    (rasio 1,777) di tablet 768x1024 tegak akan terpotong jadi cuma 42% lebar
//    tengahnya — memenggal headline dan membuang wordmark. `min-width` nol
//    menangkap itu; `orientation` menangkapnya.
//    ⚠ Ini koreksi atas perintah awal Owner yang menyuruh "cover" tanpa
//      mengukur rasionya, dan Owner mencatatnya sebagai koreksi.
//
// 5. SATU gambar diunduh, NOL PERNAH DUA. `<picture>` + `media` membuat
//    peramban mengambil satu sumber saja. ⚠ Dua `<img>` yang salah satunya
//    disembunyikan CSS akan mengunduh KEDUANYA — bentuk itu sengaja dihindari.
//
// 6. WEBP q=90, PNG jadi cadangan. Diukur: 273 KB / 233 KB lawan 2,08 MB /
//    1,92 MB — dan gzip NOL menolong gambar (99%), jadi angka mentah inilah
//    yang benar-benar lewat kabel. q=90 adalah SIKUnya: di bawahnya kerusakan
//    naik cepat (q=75 -> 9,23% piksel subjek bergeser), di atasnya ukuran naik
//    cepat tanpa perbaikan berarti (q=97 -> 4,07%, +60% byte).
//
// 8. PANEL TEMBUS PANDANG — dan alphanya HASIL PENGUKURAN (revisi Owner, 10
//    Sep 2026). Kartu legap terbaca seperti komponen bawaan yang DITEMPEL di
//    atas gambar. Panel gelap + blur membuatnya bagian dari layar yang sama.
//
//    ⛔ Ongkosnya: teks kartu kini duduk di atas GAMBAR — jadi kontrasnya
//      diukur terhadap backdrop yang BENAR-BENAR DIGAMBAR peramban, yaitu
//      backdrop SESUDAH diburamkan. Piksel tercerah di daerah yang bisa jatuh
//      di belakang kartu: rgb(246,255,255) saat tajam, tapi cuma
//      rgb(237,168,76) sesudah blur 24px — satu piksel neon yang tersebar nol
//      lagi jadi keadaan terburuk.
//
//        alpha 0,50  utama 5,23  keterangan 4,30   GAGAL
//        alpha 0,55  utama 5,94  keterangan 4,87   LULUS  <- dipakai
//        alpha 0,72  utama 9,19  keterangan 7,55   LULUS  (versi pertama)
//
//      0,55 adalah alpha TERKECIL yang lulus — dipilih DARI BAWAH, sebab makin
//      kecil alphanya makin banyak gambar yang terbaca.
//
//    ⚠ Peramban yang nol mendukung `backdrop-filter` menggambar gambar TAJAM
//      di belakang panel, dan di sana rgb(246,255,255) kembali utuh: alpha
//      0,55 jatuh ke 2,99:1. Itu ditutup aturan `@supports not` di
//      `index.css` yang menaikkannya ke 0,80 — bukan diabaikan.
//
// 9. ORANYE KEMBALI — dan ia SAH menurut A2a: oranye "HANYA tombol aksi utama,
//    satu per layar", dan tombol ini SATU-SATUNYA aksi di layar ini. Kuota
//    oranye layar ini terpakai penuh di sini.
//
//    ⚠ Teksnya GELAP, bukan putih. `--brand-orange-foreground` bawaan mode
//      terang (putih) cuma 3,01:1 di atas oranye — GAGAL AA. Yang gelap
//      6,06:1. Lihat catatan `--login-aksi-foreground` di `index.css`.
//
// 10. POSISI DARI ANGKA GAMBARNYA, bukan dari kira-kira. Tepi kiri dan jarak
//    diukur langsung dari pikselnya:
//
//      "Melangkah maju."       y 25,0-34,4%   tepi kiri 3,77%
//      "Tetap berintegritas."  y 35,3-44,7%   tepi kiri 3,65%
//      jarak antar baris (puncak ke puncak)   97 px = 10,3% tinggi
//
//    Kartu: kiri 3,77% (sejajar headline), puncak 55% (= dasar headline 44,7%
//    + satu jarak baris 10,3%).
//
//    ⚠ `object-left` di lanskap DISENGAJA. Dengan `object-center`, layar yang
//      lebih sempit dari 16:9 memotong kiri-kanan — di 1440x900 tepi kiri
//      headline jatuh 26 px DI LUAR layar, dan "sejajar headline" jadi
//      mustahil. Dengan tepi kiri dipatok, penyimpangannya tinggal ±4 px.
//      Ongkosnya: sisi KANAN gambar yang terpotong di layar non-16:9.
//
// 7. NOL ADA WARNA LITERAL DI BERKAS INI (STANDAR_UI A7, "tidak bisa
//    ditawar"). Tirai gelap di tepi kartu lahir sebagai token `--login-scrim`
//    di `index.css`, bukan sebagai angka di sini.
//
//    ⚠ Godaan terbesarnya bernama `text-white`: di atas foto ia terasa benar,
//      dan ia MEMBUNUH mode gelap tanpa satu pun galat. Kalimat ini sengaja
//      menyebutnya — `test_kendali_pemotong_komentar_BENAR_BENAR_JALAN`
//      memakainya sebagai umpan untuk membuktikan pemeriksanya membaca KODE,
//      bukan komentar. Jangan hapus namanya dari kalimat ini.
// ============================================================================

export default function Login() {
  const handleGoogleLogin = async () => {
    await supabase.auth.signInWithOAuth({
      provider: "google",
      options: { redirectTo: `${APP_BASE_URL}/auth/callback` },
    });
  };

  // Gambar latar. `alt=""` + aria-hidden: ia hiasan, dan pembaca layar nol
  // perlu mendengarnya. Urutan <source> menentukan — yang cocok PERTAMA
  // dipakai: potret+webp, lalu lanskap+webp, lalu potret+png, lalu <img>.
  const gambar = (
    // ⚠ `block h-full w-full` di <picture> BUKAN kerapian. <picture> adalah
    //   pembungkus inline tanpa tinggi; tanpa ini `h-full` di <img> mengacu ke
    //   kotak yang nol punya tinggi, gambarnya memakai tinggi ASLINYA, dan di
    //   potret ia mendorong kartu login KE BAWAH LIPATAN — layar login tanpa
    //   tombol login, dan nol satu pun galat.
    <picture className="block h-full w-full">
      <source type="image/webp" media="(orientation: portrait)" srcSet="/login-hero-mobile.webp" />
      <source type="image/webp" srcSet="/login-hero-desktop.webp" />
      <source media="(orientation: portrait)" srcSet="/login-hero-mobile.png" />
      <img
        src="/login-hero-desktop.png"
        alt=""
        aria-hidden="true"
        className="h-full w-full object-contain landscape:object-cover landscape:object-left"
      />
    </picture>
  );

  return (
    <div className="relative min-h-screen flex flex-col bg-login-latar">
      <h1 className="sr-only">ETAMS Internal Operating System</h1>

      {/* POTRET: gambar mengambil sisa ruang di atas kartu.
          LANSKAP: gambar jadi latar penuh, kartu mengapung di atasnya. */}
      <div className="flex-1 basis-0 min-h-[38vh] overflow-hidden landscape:absolute landscape:inset-0 landscape:min-h-0">
        {gambar}
      </div>

      {/* Kartu. POTRET: di bawah gambar; tepi kirinya disejajarkan dengan tepi
          kiri headline di gambar potret (8,22% lebar) — angka yang sama
          asalnya dengan 3,77% di lanskap, cuma gambarnya yang berbeda.
          LANSKAP: berlabuh ke tepi kiri + puncak yang diukur dari headline. */}
      <div
        className="relative shrink-0 px-[8.22%] pb-8 pt-5 flex justify-center
                   landscape:absolute landscape:top-[55%] landscape:left-[3.77%]
                   landscape:p-0 landscape:justify-start"
      >
        {/* ⚠ `p-6 pb-5`, bukan `p-8`. Diukur: isinya 80 px di kartu 144 px —
            hampir dua kali tingginya sendiri. Dan padding ATAS-BAWAHNYA
            ternyata SAMA PERSIS (32/32); yang terasa timpang bukan geometri
            melainkan optik: baris kedua keterangan pendek ("masuk."), jadi
            ruang di bawahnya terbaca lebih lega. Karena sebabnya optik,
            penawarnya juga optik — bawah 20 px, atas 24 px. */}
        <Card
          className="w-full max-w-md p-6 pb-5 space-y-6 border-0 shadow-2xl
                     bg-login-panel/[0.55] backdrop-blur-xl
                     text-login-panel-foreground
                     ring-1 ring-login-scrim/25
                     landscape:max-w-sm"
          data-testid="login-card"
        >
          <div className="space-y-3">
            <Button
              data-testid="login-google-btn"
              className="w-full bg-brand-orange text-login-aksi-foreground hover:bg-brand-orange/90"
              onClick={handleGoogleLogin}
            >
              Login dengan Google
            </Button>
            <p className="text-xs text-login-panel-muted text-center">
              Hanya email yang sudah di-whitelist Owner yang dapat masuk.
            </p>
          </div>
        </Card>
      </div>
    </div>
  );
}
